import { render, staticRenderFns } from "./TileProductAverageGiveaway.vue?vue&type=template&id=5554ffe8"
import script from "./TileProductAverageGiveaway.vue?vue&type=script&lang=js"
export * from "./TileProductAverageGiveaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports